import { ShieldCheck } from "lucide-react";

/**
 * Reusable HomeRange compliance/policy bar.
 * Dark styling per the approved mockups. Used across content pages to
 * separate editorial/research information from regulated transactions.
 */
export function PolicyBar() {
  return (
    <div className="bg-charcoal text-bone/80 px-5 sm:px-10 py-4" data-testid="policy-bar">
      <div className="max-w-7xl mx-auto flex items-start gap-3">
        <span className="w-9 h-9 rounded-full border border-white/15 grid place-items-center shrink-0 mt-0.5">
          <ShieldCheck size={16} className="text-blaze" />
        </span>
        <p className="text-xs sm:text-sm leading-relaxed">
          <span className="text-blaze font-semibold">HomeRange policy:</span>{" "}
          No firearm checkout, payment, transfer, or shipment occurs on HomeRange.
          <span className="block text-bone/55">We separate editorial/research information from regulated transactions.</span>
        </p>
      </div>
    </div>
  );
}
